import React from 'react';
import { Button } from 'Components.Form';
import { withRouter } from 'react-router-dom';
var NotFoundView = function (props) { return (React.createElement("div", { id: "not-found" },
    "Woops! Couldn't find the resource requested.",
    React.createElement(Button, { onClick: function () { props.history.push('/'); } }, "Back to Safety"))); };
export default withRouter(NotFoundView);
